const authPageDocumentClass = "auth-modern-login-page";

let authPageDocumentClassCount = 0;

export function addAuthPageDocumentClass(props = {}) {
  if (props.preview === "auto" || typeof document === "undefined") {
    return false;
  }

  authPageDocumentClassCount += 1;
  document.documentElement.classList.add(authPageDocumentClass);
  document.body.classList.add(authPageDocumentClass);
  return true;
}

export function removeAuthPageDocumentClass(enabled) {
  if (!enabled || typeof document === "undefined") {
    return;
  }

  authPageDocumentClassCount = Math.max(authPageDocumentClassCount - 1, 0);
  if (authPageDocumentClassCount !== 0) {
    return;
  }

  document.documentElement.classList.remove(authPageDocumentClass);
  document.body.classList.remove(authPageDocumentClass);
}
